module.exports = __webpack_public_path__ + "static/media/weatherImage.d52bd20b.jpg";